import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import {
//   LocaltestDone,
//   fetchTestdata,
//   switchQuestion,
// } from "../../../actions/traineeAction";
import { switchQuestion } from "../../../reducers/trainee";

import { useNavigate } from "react-router-dom";
import apis from "../../../services/Apis";
import { SecurePost } from "../../../services/axiosCall";
import Alert from "../../common/alert";
import {
  Button,
  Col,
  Modal,
  Progress,
  Row,
  Spin,
  Typography,
} from "antd";
import "./portal.css";
import { fetchTestdata } from "../../../features/trianeeAsync";

const { Text } = Typography;

const Clock = ({trainee}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const trainee = useSelector((state) => state?.trianee);
    //  console.log(trainee);
  

  const [isQuickResultModalOpen, setQuickResultModalOpen] = useState(false);
  const [isCorrectionReview, setCorrectionReview] = useState(false);
  const [quickResult, setQuickResult] = useState({});
  const [minutes, setMinutes] = useState(trainee?.m_left);
  const [seconds, setSeconds] = useState(trainee?.s_left);

  useEffect(() => {
    const timer = setInterval(() => {
      if (minutes === 0 && seconds === 1) {
        clearInterval(timer);
        handleQuickResultOpen();
      } else {
        if (seconds === 0) {
          setMinutes((prev) => prev - 1);
          setSeconds(59);
        } else {
          setSeconds((prev) => prev - 1);
        }
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [minutes, seconds]);

  const handleQuickResultOpen = () => {
    setQuickResultModalOpen(true);
    // if (trainee?.socket?.current) {
    //   trainee.socket.current.disconnect();
    // }
    endTest();
  };

  const handleTestComplete = () => {
    dispatch(fetchTestdata({testid:trainee.testid, traineeid:trainee.traineeid}));
  };

  const handleReviewOpen = () => {
    setCorrectionReview(true);
    setQuickResultModalOpen(false);
  };

  const handleReviewClose = () => {
    setCorrectionReview(false);
    setQuickResultModalOpen(true);
  };

  const endTest = async () => {
    try {
      const response = await SecurePost({
        url: `${apis.END_TEST}`,
        data: {
          testid: trainee.testid,
          userid: trainee.traineeid,
        },
      });

      if (response.data.success) {
        setQuickResult(response.data.data);
      } else {
        Alert("error", "Error!", response.data.message);
      }
    } catch (error) {
      const message = error.response
        ? error.response.data.message
        : error.message;
      Alert("error", "Error!", message);
    }
  };

  return (
    <>
      <div className="clock-container-new" style={{ textAlign: "center" }}>
        {String(minutes).padStart(2, "0")}:{String(seconds).padStart(2, "0")}
      </div>

      <Modal
        open={isQuickResultModalOpen}
        footer={null}
        closable={false}
        centered
        width={550}
        style={{ borderRadius: "25px", zIndex: 999999 }}
      >
        {Object.keys(quickResult).length > 0 ? (
          <div className="quickResultModalContent">
            <Row>
              <Col span={12}>
                <div className="quickResultModalParrent">
                  <Typography className="quickResultText">Your <br /> Marks</Typography>
                  <div className="custom-progress">
                    <Progress
                      type="circle"
                      percent={quickResult?.studentScorePercentage || 0}
                      strokeColor="#FAFF1C"
                      size={10}
                      trailColor="#d3d3d3"
                      trailWidth={10}
                      strokeStyle={{ boxShadow: "0px 0px 5px rgba(0,0,0,0.2)" }}
                      format={() => (
                        <span className="progress-text-quickResult">
                          {quickResult?.studentScore}/{quickResult?.totalMarks}
                        </span>
                      )}
                    />
                  </div>
                  <Typography className="quickResultText" style={{ fontWeight: 400 }}>
                    {quickResult?.studentScorePercentage || 0}%<br />
                    {quickResult?.studentGrade || "N/A"}
                  </Typography>
                </div>
              </Col>
              <Col span={12}>
                <div className="quickResultModalParrent">
                  <Typography className="quickResultText">Average <br /> Marks</Typography>
                  <div className="custom-progress">
                    <Progress
                      type="circle"
                      percent={quickResult?.allStudentsMarksPercent || 0}
                      strokeColor="#FAFF1C"
                      size={10}
                      trailColor="#d3d3d3"
                      trailWidth={10}
                      strokeStyle={{ boxShadow: "0px 0px 5px rgba(0,0,0,0.2)" }}
                      format={() => (
                        <span className="progress-text-quickResult">
                          {quickResult?.allStudentsMarksAverage}/{quickResult?.totalMarks}
                        </span>
                      )}
                    />
                  </div>
                  <Typography className="quickResultText" style={{ fontWeight: 400 }}>
                    {quickResult?.allStudentsMarksPercent || 0}%<br />
                    {quickResult?.totalGrade || "N/A"}
                  </Typography>
                </div>
              </Col>
            </Row>
            <Row justify="center">
              <Col offset={5} span={14}>
                <div className="modalButtons">
                  <Button className="modalButtonNo" onClick={handleReviewOpen}>
                    Review Test
                  </Button>
                  <Button
                    className="modalButtonNo"
                    onClick={() => {
                      handleTestComplete();
                      navigate("/user/livetest");
                    }}
                  >
                    Return to Take Test page
                  </Button>
                  <Button
                    className="modalButtonNo"
                    onClick={() => {
                      handleTestComplete();
                      navigate("/user/testHistory");
                    }}
                  >
                    Return to Test History
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Spin size="large" />
          </div>
        )}
      </Modal>

      <Modal
        open={isCorrectionReview}
        footer={null}
        closable={false}
        centered
        onCancel={handleReviewClose}
        width={350}
        style={{ borderRadius: "25px", zIndex: 999999 }}
      >
        <p className="modalTitle">Which review option do you wish to choose:</p>
        <div className="modalButtons">
          <Button
            className="modalButtonNo"
            onClick={() => {
              handleTestComplete();
              dispatch(switchQuestion(0));
            }}
          >
            Full Review
          </Button>
          <Button
            className="modalButtonNo"
            onClick={() => {
              handleTestComplete();
              dispatch(switchQuestion(0));
              navigate(`/trainee/taketest?testid=${trainee.testid}&traineeid=${trainee.traineeid}&isCorrect=false`, {
                state: { isCorrect: false },
              });
            }}
          >
            Correction Review
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default Clock;
